const Footer = () => {

    return (
        <footer className="pt-7 pb-12  items-center bg-black text-yellow-500 w-full h-4 " >
            <p className="text-center ">
                Gen Z Tech Copyright ©2023. All rights reserved
            </p>
        </footer>
    )
}
export default Footer;